import { StyleSpecification } from 'maplibre-gl';
import { UDViewMapStyle } from '../../../udView/udview';
import styleBlue from './styles/style-blue.json';
import styleClassic from './styles/style-classic.json';
import styleDark from './styles/style-dark.json';
import styleDark2 from './styles/style-dark2.json';
import styleHybrid from './styles/style-hybrid.json';
import styleLight from './styles/style-light.json';
import styleNav from './styles/style-nav.json';
import styleSatellite from './styles/style-satellite.json';
import styleStreets from './styles/style-streets.json';
import styleTerrainSatellite from './styles/style-terrain-satellite.json';
import styleTerrainStreets from './styles/style-terrain-streets.json';

const map: Record<UDViewMapStyle, any> = {
    [UDViewMapStyle.dark]: styleDark,
    [UDViewMapStyle.light]: styleLight,
    [UDViewMapStyle.blue]: styleBlue,
    [UDViewMapStyle.streets]: styleStreets,
    [UDViewMapStyle.satellite]: styleSatellite,
    [UDViewMapStyle.terrainStreets]: styleTerrainStreets,
    [UDViewMapStyle.terrainSatellite]: styleTerrainSatellite,
    [UDViewMapStyle.darkReversed]: styleDark2,
    [UDViewMapStyle.hybrid]: styleHybrid,
    [UDViewMapStyle.classic]: styleClassic
};

export function getMapStyle(mapStyle: UDViewMapStyle): StyleSpecification {
    const base = map[mapStyle];
    return structuredClone({
        ...base,
        layers: [...base.layers, ...styleNav.layers],
        sources: {
            ...base.sources,
            ...styleNav.sources
        }
    });
}
